/**
 * Shared validation error messages for Customer and Supplier forms
 * これらのメッセージは顧客と仕入先フォームで共有されています
 */

// 基本情報 (Basic Information)
export const VALIDATION_MESSAGES = {
  // Gali Code
  GALI_CODE_FORMAT: 'Gali取引先コードは半角数値で入力ください。',

  // Official Name
  OFFICIAL_NAME_REQUIRED: '正式名称は必須入力項目です。',
  OFFICIAL_NAME_MAX_LENGTH: '正式名称は200文字までで入力ください。',

  // Abbreviated Name
  ABBREVIATED_NAME_REQUIRED: '略称（簡易名称）は必須入力項目です。',
  ABBREVIATED_NAME_MAX_LENGTH: '略称（簡易名称）は100文字までで入力ください。',

  // Branch/Department
  BRANCH_DEPARTMENT_MAX_LENGTH: '支店・部門は100文字までで入力ください。',

  // Katakana Name
  KATAKANA_NAME_FORMAT: 'は半角カタカナで入力ください。',
  COMPANY_NAME_KANA_REQUIRED: '取引先名カナは必須入力項目です。',

  // Postal Code
  CURRENT_ADDRESS_POSTAL_CODE1_REQUIRED: '所在地 郵便番号（前半）は必須入力項目です。',
  CURRENT_ADDRESS_POSTAL_CODE2_REQUIRED: '所在地 郵便番号（後半）は必須入力項目です。',
  HEAD_OFFICE_POSTAL_CODE1_REQUIRED: '本社情報 郵便番号（前半）は必須入力項目です。',
  HEAD_OFFICE_POSTAL_CODE2_REQUIRED: '本社情報 郵便番号（後半）は必須入力項目です。',

  CURRENT_ADDRESS_POSTAL_CODE1_HALF_WIDTH: '所在地   郵便番号（前半）は半角数値で入力ください。',
  CURRENT_ADDRESS_POSTAL_CODE2_HALF_WIDTH: '所在地   郵便番号（後半）は半角数値で入力ください。',
  HEAD_OFFICE_POSTAL_CODE1_HALF_WIDTH: '本社情報   郵便番号（前半）は半角数値で入力ください。',
  HEAD_OFFICE_POSTAL_CODE2_HALF_WIDTH: '本社情報   郵便番号（後半）は半角数値で入力ください。',

  CURRENT_ADDRESS_POSTAL_CODE1_FORMAT: '所在地   郵便番号（前半）は3桁までで入力ください。',
  CURRENT_ADDRESS_POSTAL_CODE2_FORMAT: '所在地   郵便番号（後半）は4桁までで入力ください。',
  HEAD_OFFICE_POSTAL_CODE1_FORMAT: '本社情報   郵便番号（前半）は3桁までで入力ください',
  HEAD_OFFICE_POSTAL_CODE2_FORMAT: '本社情報   郵便番号（後半）は4桁までで入力ください。',

  // Address
  CURRENT_ADDRESS_ADDRESS1_REQUIRED: '所在地 住所１は必須入力項目です。',
  CURRENT_ADDRESS_ADDRESS2_REQUIRED: '所在地 住所２は必須入力項目です。',
  HEAD_OFFICE_ADDRESS1_REQUIRED: '本社情報 住所１は必須入力項目です。',
  HEAD_OFFICE_ADDRESS2_REQUIRED: '本社情報 住所２は必須入力項目です。',

  // Phone & Fax
  PHONE_FORMAT: '電話番号は数値で入力ください。',
  PHONE_REQUIRED: '所在地 電話は必須入力項目です。',
  FAX_FORMAT: 'FAX番号は数値で入力ください。',
  FAX_REQUIRED: '所在地 FAXは必須入力項目です。',

  // Representatives
  REPRESENTATIVES_MAX_COUNT: '野原担当者は最大10名まで登録可能です。',
  REPRESENTATIVE_DEPARTMENT_REQUIRED: '担当部署は必須選択項目です。',
  REPRESENTATIVE_SALES_PERSON_REQUIRED: '野原担当は必須入力です。',
  REPRESENTATIVES_MIN_REQUIRED: '野原担当は必須入力です。',

  // Factory (Supplier specific but shared across supplier forms)
  FACTORY_POSTAL_CODE1_FORMAT: '工場郵便番号（前半）は3桁の半角数字で入力してください。',
  FACTORY_POSTAL_CODE2_FORMAT: '工場郵便番号（後半）は4桁の半角数字で入力してください。',
  FACTORY_PHONE_FORMAT: '工場電話番号は半角または全角数字で入力してください。',
  FACTORY_FAX_FORMAT: '工場FAX番号は半角または全角数字で入力してください。',

  // Contact Officer (Factory contacts)
  CONTACT_OFFICER_PHONE_FORMAT: '電話番号は半角または全角数字で入力してください。',
  CONTACT_OFFICER_EMAIL_INVALID: '有効なメールアドレスを入力してください。',
  CONTACT_OFFICER_FAX_FORMAT: 'FAX番号は半角または全角数字で入力してください。',

  // Qualified Personnel
  QUALIFIED_PERSONNEL_MUST_BE_NUMBER: 'は半角数値で入力ください。',
  QUALIFIED_PERSONNEL_MUST_BE_NON_NEGATIVE: '正の整数で入力してください。',
  QUALIFIED_PERSONNEL_MUST_BE_INTEGER: 'は整数で入力してください。',

  // Mixer Information
  MIXER_CARDINALITY_MUST_BE_NUMBER: '基数は半角数値で入力ください。',
  MIXER_CARDINALITY_MUST_BE_NON_NEGATIVE: 'ミキサ基数正の整数で入力してください。',
  MIXER_CARDINALITY_MUST_BE_INTEGER: 'ミキサ基数は整数で入力してください。',

  // Transport Vehicles
  TRANSPORT_VEHICLE_MUST_BE_NUMBER: 'は半角数値で入力ください。',
  TRANSPORT_VEHICLE_MUST_BE_NON_NEGATIVE: '正の整数で入力してください。',
  TRANSPORT_VEHICLE_MUST_BE_INTEGER: 'は整数で入力してください。',

  // Raw Materials
  CEMENT_MAKER_REQUIRED: 'セメントメーカーは必須入力項目です。',

  // Validate member forms
  // Members (担当者) validations
  MEMBER_LAST_NAME_REQUIRED: '姓は必須入力項目です。',
  MEMBER_FIRST_NAME_REQUIRED: '名は必須入力項目です。',
  MEMBER_LAST_NAME_KANA_FORMAT: '姓の半角ｶﾅは半角ｶﾅで入力ください。',
  MEMBER_FIRST_NAME_KANA_FORMAT: '名の半角ｶﾅは半角ｶﾅで入力ください。',
  MEMBER_DEPARTMENT_REQUIRED: '所属部署は必須選択項目です。',
  MEMBER_AUTHORITIES_REQUIRED: '権限は必須選択項目です。',
  MEMBER_IS_SELECTABLE_REQUIRED: '担当者選択は必須選択項目です。',
  MEMBER_EMAIL_REQUIRED: 'メールアドレスは必須選択項目です。',
  MEMBER_EMAIL_INVALID: 'メールアドレスは所定の書式と一致しません。',
  MEMBER_EMAIL_DOMAIN_RESTRICTED: '「@nohara-inc.co.jp」のメールアドレスのみご利用いただけます。',
  MEMBER_PHONE_FORMAT_HYPHEN_NUMERIC: '電話番号は半角数字、半角ハイフンで入力ください。',
  MEMBER_CODE_REQUIRED: '担当者IDは必須入力項目です。',
  MEMBER_CODE_NUMERIC_ONLY: '担当者IDは半角数字で入力ください。',
  MEMBER_CODE_NOT_ZERO: '担当者IDは必須入力項目です。',
} as const;

// Supplier specific messages
export const SUPPLIER_MESSAGES = {
  SUPPLIER_NAME_KATAKANA_REQUIRED: '仕入先名（カタカナ）は必須入力項目です。',
  SUPPLIER_NAME_KATAKANA_FORMAT: '仕入先名（カタカナ）は半角カタカナで入力ください。',
  SUPPLIER_TYPE_REQUIRED: '仕入先種別は必須選択項目です。',
  SUPPLIER_CATEGORY_REQUIRED: '仕入先カテゴリは必須選択項目です。',
  SUPPLIER_CATEGORY_DETAIL_REQUIRED: '仕入先区分は必須入力項目です。',
  COMPANY_TYPE_MUST_BE_SUPPLIER: '会社種別は「仕入先」を選択してください。',
} as const;

// Customer specific messages
export const CUSTOMER_MESSAGES = {
  CUSTOMER_NAME_KATAKANA_REQUIRED: '取引先名カナは必須入力項目です。',
  CUSTOMER_NAME_KATAKANA_FORMAT: '取引先名（カタカナ）は半角カタカナで入力ください。',
  CUSTOMER_CATEGORY_REQUIRED: '得意先カテゴリは必須選択項目です。',
  CUSTOMER_CATEGORY_DETAIL_REQUIRED: '得意先カテゴリは必須選択項目です。',
} as const;

// Construction specific messages
export const CONSTRUCTION_MESSAGES = {
  COMPANY_NAME_KANA_REQUIRED: '取引先名カナは必須入力項目です。',
  REPRESENTATIVE_SALES_PERSON_REQUIRED: '野原担当は必須入力です。',
} as const;

// Witness Company specific messages
export const WITNESS_MESSAGES = {
  OFFICIAL_NAME_REQUIRED_SHORT: '正式名称は必須入力項目です。',
  TEL_REQUIRED: '電話は必須入力項目です。',
  TEL_FORMAT: '電話番号は半角数字で入力してください。',
  CONTACT_TEL_FORMAT: '連絡責任者TEL番号は半角数字で入力してください。',
  FAX_REQUIRED: 'FAXは必須入力項目です。',
  FAX_FORMAT: 'FAX番号は半角数字で入力してください。',
} as const;
